import React from 'react';

function badge(status, error, sm) {
  const p = sm !== false ? '2px 8px' : '2px 6px';
  const f = sm !== false ? '11px' : '10px';
  if (status === 'ready')    return <span style={{ background:'#dcfce7',color:'#166534',borderRadius:'4px',padding:p,fontSize:f }}>✅ Ready</span>;
  if (status === 'no_tag')   return <span style={{ background:'#f3f4f6',color:'#6b7280',borderRadius:'4px',padding:p,fontSize:f }}>— No Tag</span>;
  if (status === 'no_count') return <span style={{ background:'#fef3c7',color:'#92400e',borderRadius:'4px',padding:p,fontSize:f }}>⚠️ No Count</span>;
  if (status === 'failed')   return <span title={error} style={{ background:'#fee2e2',color:'#991b1b',borderRadius:'4px',padding:p,fontSize:f }}>❌ Failed</span>;
  return null;
}

function PreviewTable({ data }) {
  return (
    <>
      <div style={{ display:'flex',gap:'10px',marginBottom:'16px',flexWrap:'wrap' }}>
        {[['Total Entities',data.summary.total,'#3b82f6'],['Ready to Save',data.summary.ready,'#10b981'],['Failed / No Count',data.summary.failed,'#ef4444']].map(([label,val,color]) => (
          <div key={label} style={{ background:'#f9fafb',border:`1px solid ${color}44`,borderRadius:'8px',padding:'10px 16px',minWidth:'140px' }}>
            <div style={{ fontSize:'11px',color:'#6b7280',textTransform:'uppercase',letterSpacing:'0.4px' }}>{label}</div>
            <div style={{ fontSize:'22px',fontWeight:'700',color }}>{val}</div>
          </div>
        ))}
      </div>
      <table style={{ width:'100%',borderCollapse:'collapse',fontSize:'13px' }}>
        <thead>
          <tr style={{ background:'#f3f4f6',borderBottom:'2px solid #e5e7eb' }}>
            <th style={{ padding:'8px 10px',textAlign:'left',fontWeight:'600',color:'#374151' }}>Name / Email</th>
            <th style={{ padding:'8px 10px',textAlign:'left',fontWeight:'600',color:'#374151' }}>Type</th>
            <th style={{ padding:'8px 10px',textAlign:'center',fontWeight:'600',color:'#374151' }}>Current DB</th>
            <th style={{ padding:'8px 10px',textAlign:'center',fontWeight:'600',color:'#10b981' }}>Live from GHL ✦</th>
            <th style={{ padding:'8px 10px',textAlign:'center',fontWeight:'600',color:'#374151' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.preview.map((a) => (
            <React.Fragment key={a.agentKey}>
              <tr style={{ borderBottom:'1px solid #e5e7eb',background:a.agentType==='group'?'#eff6ff':'#fff' }}>
                <td style={{ padding:'9px 10px' }}>
                  <div style={{ fontWeight:'600',color:'#111827' }}>{a.name}</div>
                  <div style={{ fontSize:'11px',color:'#9ca3af' }}>{a.email||a.ghlLocationId}</div>
                  {a.ghlLocationName && a.ghlLocationName!==a.name && <div style={{ fontSize:'11px',color:'#6b7280' }}>📍 {a.ghlLocationName}</div>}
                  <div style={{ fontSize:'10px',color:'#c4b5fd' }}>Campaign: {a.campaignId}</div>
                </td>
                <td style={{ padding:'9px 10px' }}>
                  <span style={{ background:a.agentType==='group'?'#dbeafe':'#f3f4f6',color:a.agentType==='group'?'#1d4ed8':'#374151',borderRadius:'4px',padding:'2px 8px',fontSize:'11px',fontWeight:'600' }}>
                    {a.agentType==='group'?'👥 GROUP':'👤 Agent'}
                  </span>
                </td>
                <td style={{ padding:'9px 10px',textAlign:'center',color:'#6b7280',fontWeight:'500' }}>
                  {a.currentCount!==null?a.currentCount.toLocaleString():<span style={{ color:'#d1d5db',fontStyle:'italic' }}>—</span>}
                </td>
                <td style={{ padding:'9px 10px',textAlign:'center',fontWeight:'700',fontSize:'15px',color:a.fetchedCount!==null?'#059669':'#9ca3af' }}>
                  {a.fetchedCount!==null?a.fetchedCount.toLocaleString():'—'}
                </td>
                <td style={{ padding:'9px 10px',textAlign:'center' }}>{badge(a.status,a.error)}</td>
              </tr>
              {a.members && a.members.map((m,mi) => (
                <tr key={`${a.agentKey}-m${mi}`} style={{ borderBottom:'1px solid #f0f0f0',background:'#f8fbff' }}>
                  <td style={{ padding:'6px 10px 6px 28px' }}>
                    <div style={{ fontSize:'12px',fontWeight:'500',color:'#374151' }}>↳ {m.name}</div>
                    <div style={{ fontSize:'11px',color:'#9ca3af' }}>{m.email}</div>
                    {m.ghlFilterTag && <div style={{ fontSize:'10px',color:'#6366f1' }}>🏷 tag: {m.ghlFilterTag}</div>}
                  </td>
                  <td style={{ padding:'6px 10px',fontSize:'11px',color:'#6b7280' }}>Member</td>
                  <td style={{ padding:'6px 10px',textAlign:'center',color:'#6b7280',fontSize:'12px' }}>
                    {m.currentCount!==null?m.currentCount.toLocaleString():<span style={{ color:'#d1d5db',fontStyle:'italic' }}>—</span>}
                  </td>
                  <td style={{ padding:'6px 10px',textAlign:'center',fontWeight:'600',fontSize:'13px',color:m.fetchedCount!==null?'#059669':'#9ca3af' }}>
                    {m.fetchedCount!==null?m.fetchedCount.toLocaleString():m.status==='no_tag'?<span style={{ fontStyle:'italic',fontWeight:'400',fontSize:'11px',color:'#9ca3af' }}>no tag</span>:'—'}
                  </td>
                  <td style={{ padding:'6px 10px',textAlign:'center' }}>{badge(m.status,m.error,false)}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default PreviewTable;
